import ResetPasswordWithToken from './ResetPasswordWithToken';
export default ResetPasswordWithToken;
